import { Controller } from "@hotwired/stimulus";

// Tiny toggle controller used by each unclaimed-collaborator row in the
// collaborators list. Swaps between a "display" view (email + edit
// pencil, or "Add email" link when blank) and a "form" view (email
// input + Save/Cancel). The form itself is a regular Turbo PATCH that
// re-renders the whole list on success -- so we don't have to manually
// snap back to display mode here.
//
// Targets:
//   display - the read-only display row
//   form    - the inline editor (initially hidden)
//   input   - the email input inside the form, focused on edit
export default class extends Controller {
  static targets = ["display", "form", "input"];

  edit(event) {
    event?.preventDefault();
    this.displayTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");
    setTimeout(() => this.inputTarget?.focus(), 20);
  }

  cancel(event) {
    event?.preventDefault();
    this.formTarget.classList.add("hidden");
    this.displayTarget.classList.remove("hidden");
    if (this.hasInputTarget) {
      this.inputTarget.value = this.inputTarget.dataset.originalValue || "";
    }
  }
}
